<template>
  <div>
    <DivLinkButton
      class="member-buttons"
      v-for="member in membersByUnitId(id,showActive,showOnLeave,showDismissed,showRecruit,searchString)"
      v-bind:class="{active: (member.member_status === 0), recruit: (member.member_status === 3),
          dismissed: (member.member_status === 1), onleave: (member.member_status === 2)}"

      v-bind:key="member.id"
      v-bind="{routeName: 'AdminMember', routeParams: {member_id: member.member_id}}"
    >
      {{ member.callsign }}
    </DivLinkButton>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex"
import HideableDiv from "../basic_comp/HideableDiv"
import DivLinkButton from "../basic_comp/DivLinkButton"

export default {
  name: "UnitAdminOverviewComp",
  components: {
    HideableDiv,
    DivLinkButton
  },
  props: {

    id: {
      type: Number,
      default: true
    },
    name: {
      type: [String, Number],
      default: true
    },
    showActive: {
      type: Boolean,
      default: true
    },
    showOnLeave: {
      type: Boolean,
      default: true
    },
    showDismissed: {
      type: Boolean,
      default: null
    },
    showRecruit: {
      type: Boolean,
      default: null
    },
    searchString: {
      type: String,
      default: ""
    }

  },
  mounted () {

    console.log("mounted");
    this.loadData();
  },
  data() {

    return {

      campaign_to_show: 0
    }
  },
  computed: {

    ...mapState('memberAdmin', {
      base_units: state => state.base_units
    }),

    ...mapState('campaignAdmin', {
      campaigns: state => state.campaigns
    }),

    ...mapState('unitAdmin', {
      mission_unit_active_members: state => state.mission_unit_active_members,
      mission_unit_attending_members_count: state => state.mission_unit_attending_members_count
    }),

    ...mapGetters("memberAdmin", [
      "membersByUnitId",
      "memberPhantoms"
    ]),

    ...mapGetters("unitAdmin", [
      "filterByKeys",
    ]),


  },
  methods: {

    loadData: function() {

      console.log("loading");
      if(this.mission_unit_active_members.length == 0){

        this.$store.dispatch('unitAdmin/loadStoreData',
          {
            caller: this.$options.name,
            call_object: {
              view: "mission_unit_active_members"
            },
            data_array_name: "mission_unit_active_members"
          });
      }

      if(this.mission_unit_attending_members_count.length == 0){

        this.$store.dispatch('unitAdmin/loadStoreData',
          {
            caller: this.$options.name,
            call_object: {
              view: "mission_unit_attending_members_count"
            },
            data_array_name: "mission_unit_attending_members_count"
          });
      }
    }

  }
}
</script>

<style scoped>

.member-buttons{
  font-size: 1em;
  margin: 2px 0px 0px 20px;
  padding-top: 5px;
  padding-bottom: 5px;
}

.member-buttons:hover{
  font-size: 1em;
  margin: 2px 0px 0px 20px;
  padding-top: 5px;
  padding-bottom: 5px;
}


.active{
  background-color: rgba(0, 255, 0, 0.25);
}

.onleave{
  background-color: rgba(255, 255, 0, 0.25);
}

.dismissed{
  background-color: rgba(255, 0, 0, 0.25);
}

.recruit{
  background-color: rgba(0, 157, 255, 0.43);
}
</style>



// WEBPACK FOOTER //
// src/components/admin/UnitAdminOverviewComp.vue